import { Logger } from '@nab/nab-x-sdk-browser';
import { getSettings } from './logConfig';

export function configureLogger(wrapper?: HTMLElement) {
    log = new Logger({...getSettings()["dev"], wrapper: (wrapper as any).host || wrapper });
}

export let log;